import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import dayjs from "dayjs";
import { Sheet, SheetContent } from "../../components/ui/sheet";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";

const AdrawingtableInputDrawer = ({
  title,
  open,
  rows,
  rowIndex,
  editRow,
  onClose,
  onChangeRow,
  onMovePrev,
  onMoveNext,
  onSave,
  fields, // SHEET_FIELDS
}) => {
  if (!editRow) return null;

  return (
    <Sheet open={open} onOpenChange={(v) => !v && onClose()}>
      <SheetContent side="right" className="w-3/4 p-0 gap-0 sm:max-w-[440px] flex flex-col h-full [&_label]:text-xs [&_input]:!text-xs">
        {/* ===== Header (고정) ===== */}
        <div className="flex flex-shrink-0 items-center justify-center gap-2 border-b border-[#e0e0e0] px-4 py-3">
          <Button variant="ghost" size="icon" onClick={onMovePrev} disabled={rowIndex === 0}>
            <ChevronLeft />
          </Button>

          <div className="font-semibold">
            {title} · {rowIndex + 1} / {rows.length}
          </div>

          <Button variant="ghost" size="icon" onClick={onMoveNext} disabled={rowIndex === rows.length - 1}>
            <ChevronRight />
          </Button>
        </div>

        {/* ===== Scroll Area ===== */}
        <div className="flex flex-1 flex-col gap-3 overflow-y-auto px-4 py-2">
          {fields.map((field) => {
            if (field.editable) {
              if (field.type === "date") {
                return <EditDateTextField key={field.key} editRow={editRow} field={field} onChangeRow={onChangeRow} />;
              }

              return <EditStringTextField key={field.key} editRow={editRow} field={field} onChangeRow={onChangeRow} />;
            }

            return <ReadTextFieldType key={field.key} editRow={editRow} field={field} />;
          })}
        </div>

        {/* ===== Footer (고정) ===== */}
        <div className="flex flex-shrink-0 gap-2 border-t border-[#e0e0e0] px-4 py-3">
          <Button className="flex-1" onClick={onSave}>
            저장
          </Button>
          <Button variant="outline" className="flex-1" onClick={onClose}>
            닫기
          </Button>
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default AdrawingtableInputDrawer;

const ReadTextFieldType = ({ editRow, field }) => {
  const value = editRow[field.key];

  return (
    <div className="space-y-1.5">
      <Label>{field.label}</Label>
      <Input
        type="text"
        value={field.type === "date" && value ? dayjs(value).format("YYYY-MM-DD") : value ?? "-"}
        disabled
      />
    </div>
  );
};

const EditStringTextField = ({ editRow, field, onChangeRow }) => {
  const value = editRow[field.key];

  return (
    <div className="space-y-1.5">
      <Label>{field.label}</Label>
      <Input
        type="text"
        value={value ?? ""}
        className="bg-[#f9fcff]"
        onChange={(e) =>
          onChangeRow({
            ...editRow,
            [field.key]: e.target.value,
          })
        }
      />
    </div>
  );
};

const EditDateTextField = ({ editRow, field, onChangeRow }) => {
  const value = editRow[field.key];

  return (
    <div className="space-y-1.5">
      <Label>{field.label}</Label>
      <Input
        type="date"
        value={dayjs(value).format("YYYY-MM-DD")}
        className="bg-[#f9fcff]"
        onChange={(e) =>
          onChangeRow({
            ...editRow,
            [field.key]: new Date(e.target.value),
          })
        }
      />
    </div>
  );
};
